import he from 'he';

/**
 * Рекурсивно декодирует HTML-энтити во всех строковых значениях объекта
 */
export function decodeHtmlEntities<T>(data: T): T {
  if (typeof data === 'string') {
    return he.decode(data) as T;
  }

  if (Array.isArray(data)) {
    // TODO: Улучшить типизацию для безопасного возврата массивов
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return data.map(item => decodeHtmlEntities(item)) as T;
  }

  if (data !== null && typeof data === 'object') {
    const decodedData: Record<string, unknown> = {};
    const entries = Object.entries(data as Record<string, unknown>);
    
    entries.forEach(([key, value]) => {
      decodedData[key] = decodeHtmlEntities(value);
    });
    
    return decodedData as T;
  }

  return data;
} 